<template>
  <div class="uk-container">
    <div class="video-wrapper">
      <iframe
        :src="videoUrl"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        class="uk-width-1-1"
      ></iframe>
    </div>
  </div>
</template>


<script>
export default {
  name: 'VideoCategory',
  props: {
    videoUrl: {
      type: String, // or Array, Object, etc., depending on your data type
      required: true
    }
  },
  // data() {
  //   return {
  //     videoId: 'YjeiqaZ4_nU' // Replace with your video ID
  //   };
  // },
  // computed: {
  //   videoUrl() {
  //     return `https://www.youtube.com/embed/${this.videoId}`;
  //   }
  // }
}
</script>

<style scoped>
.video-wrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
  max-width: 100%;
  background: #000;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
